<template>
  <div class="sign-engagement">
    <HeroBanner :title="'Sign Engagement Letter'" :subtitle="'This is a legally binding agreement'"/>
    <div class="col1">
      <div class="sign-engagement__page">
        <div class="sign-engagement__page__letter" ref="letter" v-if="currentUserProfile">
          <table>
            <tr>
              <td class="sign-engagement__page__letter__logo">
                <img src="@/assets/img/eop-law-logo.png" alt="EOP Law Logo"/>
              </td>
              <td class="small">
                <p>
                  <strong>SPENCER K. HUNTER</strong><br/>
                  DIRECT DIAL:  (971) 230-1067 <br/>
                  EMAIL:  SPENCER@EOPLAW.COM
                </p>
                <p>
                  LICENSED IN OREGON<br/>
                  REGISTERED US PATENT ATTORNEY
                </p>
              </td>
            </tr>
          </table>
          <br/>
          <p style="text-align:center" v-html="currentDate"></p>
          <p>RE: 	Engagement letter</p>
          <p>Dear {{ currentUserProfile.firstName }}:</p>
          <p>Thank you for choosing our firm to represent {{ currentUserProfile.businessName }} with respect to the intellectual property matters that you may refer to us from time to time. We are sending this letter to you pursuant to a State Bar recommendation that lawyers and clients enter into written fee agreements. </p>
          <p>We have agreed to initially represent {{ currentUserProfile.businessName }} in connection with the preparation and filing of a U.S. provisional patent application. Our agreed fee for such services is a FLAT FEE of ${{ price }} USD inclusive of all costs and fees. </p>
          <p>Future services may be provided by agreement between {{ currentUserProfile.businessName }} and Spencer K. Hunter and/or the Firm. Such services are generally provided on an hourly basis when no other fee arrangement is requested. My rate is $415 per hour. </p>
          <p>At the request of {{ currentUserProfile.businessName }} and upon our written confirmation, we are happy to provide additional specifically agreed to services on a flat fee or hourly basis. When work subject to a flat fee is performed, we will not bill you any amount in excess of the flat fee agreement without first obtaining written consent from {{ currentUserProfile.businessName }}'s in-house legal counsel for unusual or extenuating circumstances.</p>
          <p>We may incur various costs and assess other charges in providing our services to clients, such as patent fees and trademark fees payable to the USPTO or costs and service fees charged by Foreign Associates for internationally filed patents and trademarks. These costs may be substantial. Thus, we may, at our discretion, ask that {{ currentUserProfile.businessName }} deposit certain amounts into a client trust account, which we may draw upon to pay current and future costs or legal fees, upon {{ currentUserProfile.businessName }}'s agreement for such services.</p>
          <p>Please note that we do not bill our clients for our normal overhead costs incurred pursuant to our firm's services, with such non-billed services including, for example, docketing of legal matters, reporting on status of legal matters, internal photocopying, regular mail, normal fax and telephone expenses, and staff overtime.  Our monthly invoices summarize our services rendered on a daily basis for those matters charged hourly, setting forth the total charges for fees plus applicable out-of-pocket expenses. For those matters charged pursuant to a flat fee or minimum fixed fee agreement, the monthly invoices set forth the charges for the task and the corresponding fee on a per-matter basis, plus any applicable out-of-pocket expenses advanced on behalf of {{ currentUserProfile.businessName }} which are not inclusive to the flat fee or the minimum fee.  Monthly invoices are due upon receipt.  </p>
          <p>Past due invoices may accrue a finance charge at the rate of 1.5% per month. </p>
          <p>You have the right to terminate our engagement at any time, but you would remain responsible for the payment of all outstanding fees and expenses.  In addition, we reserve the right to discontinue our representation of you for any reason consistent with our ethical duties, including any failure to pay when due any obligation owed.  </p>
          <p>Please sign this letter below, to show your agreement to the terms of our engagement, and then please return it to me as soon as possible.  This confirms that we and you will accept electronic signatures pursuant to the Uniform Electronic Transaction Act, so emailed signatures are legally binding.  We will begin representing you and working on your legal matters after we have received from you a signed copy of this letter.</p>
          <p>Lastly, if you ever have a question about a bill or about any other aspect of our representation, please discuss it candidly with me.  It is obviously in our mutual interests that we discuss with you all issues involving our representation.  Please call me directly if you have any questions in this regard. I look forward to working with you.  </p>
          <br/>
          <p>
            ELLIOTT, OSTRANDER &amp; PRESTON, P.C.
          </p>
          <table>
            <tr>
              <td class="signature-line">
                <img class="spencer-signature" src="@/assets/img/spencer-signature.png" alt="Spencer Signature"/><br/>
              </td>
            </tr>
            <tr>
              <td>
                Spencer K. Hunter<br/>
                Partner, Registered U.S. Patent Attorney
              </td>
            </tr>
          </table>
          <br/><br/>
          <p>
            Acknowledged and Agreed on behalf of:
          </p>
          <br/>
          <p>
            {{ currentUserProfile.businessName }}
          </p>
          <br/>
          <table>
            <tr>
              <td class="signature-line">
                <img class="user-signature" :src="signatureDataUrl" v-if="signatureDataUrl" alt="User Signature"/>
              </td>
              <td class="signature-line">
                <div class="current-date" v-html="currentDate"/>
              </td>
            </tr>
            <tr>
              <td style="width: 65%">
                {{ currentUserProfile.firstName }} {{ currentUserProfile.lastName }}
              </td>
              <td style="position: relative; width: 35%">
                Date
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="sign-engagement__footer">
        <div>
          <canvas ref="canvas" />
          <p>Sign above with your mouse or trackpad</p>
          <div class="sign-engagement__footer__actions">
            <button @click="clear">Clear Signature</button>
            <button @click="submit" :disabled="!signatureDataUrl || pending"  v-html="pending ? 'Please wait...' : 'Submit'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { packagesCollection } from '@/library/firebase'
import * as fb from '@/library/firebase'
import HeroBanner from '@/components/HeroBanner'
import jsPDF from 'jspdf'
import moment from 'moment'
import router from '@/router'
import SignaturePad from 'signature_pad'
const sendEmail = fb.funcs.httpsCallable('sendEmail')

export default {
  name: 'SignEngagementLetter',
  components: {
    HeroBanner
  },
  data() {
    return {
      signatureImgUrl: '',
      signaturePad: null,
      signatureDataUrl: null,
      packageData: null,
      pending: false,
      uploadProgress: 0
    }
  },
  computed: {
    ...mapGetters([
      'currentUserProfile'
    ]),
    ...mapState([
      'adminEmail',
    ]),
    currentDate() {
      return moment().format('MMMM Do, YYYY')
    },
    price() {
      if (this.currentUserProfile?.stripe?.customPrice) {
        return this.currentUserProfile?.stripe?.customPrice
      }
      else if (this.currentUserProfile?.packageVariant) {
        const variant = this.currentUserProfile?.packageVariant ? this.packageData?.variants.find(v => v.id === this.currentUserProfile?.packageVariant) : 0
        return this.packageData?.price + variant.price
      }
      else {
        return this.packageData?.price
      }
    }
  },
  mounted() {
    this.signaturePad = new SignaturePad(this.$refs.canvas, {
      onEnd: () => {
        this.signatureDataUrl = this.signaturePad?.toDataURL()
      }
    })

    window.addEventListener('resize', this.resizeCanvas)
    this.resizeCanvas()

    // Fetch data about packages to get pricing
    packagesCollection.doc(this.currentUserProfile?.package).get().then(doc => {
      this.packageData = doc.data()
    })
  },
  methods: {
    ...mapActions([
      'setTimelineStep'
    ]),
    generatePDF() {
      let doc = new jsPDF('p', 'pt', 'letter')
      let source = this.$refs.letter
      doc.html(source, {
        callback: (doc) => {
          // Upload the generated PDF to blob storage
          const blobPDF = new Blob([ doc.output('blob') ], { type: 'application/pdf'})
          this.upload(blobPDF)
        }
      })
    },
    dataURLtoBlob(dataurl) {
      let arr = dataurl.split(','), mime = arr[0].match(/:(.*?)/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
      while(n--){
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {type:mime})
    },
    upload(blob){
      const uid = this.currentUserProfile?.uid;
      const storageRef = fb.storage.ref(`docs/${uid}/engagement-letter.pdf`).put(blob)
      storageRef.on('state_changed',
        snapshot => {
          this.uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes) * 100
        },
        error => {
          console.error(error.message)
          this.pending = false
        },
        () => {
          this.uploadProgress = 100
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.signatureImgUrl = url
            this.pending = false

            // Send email to user
            let to = this.currentUserProfile?.email
            let subject = 'Action required: Authorize payment. PortlandPatent.com engagement letter has been signed.'
            let link = `${process.env.VUE_APP_SITE_URL}/`
            let message = `<h1>Action Required</h1><p>Please log in to authorize your credit card payment. Visit <a href="${link}">${link}</a> to submit authorization.</p>`
            sendEmail({ to, subject, message }).catch(() => {})

            // Send email to admin
            to = this.adminEmail
            subject = `Engagement letter has been signed by ${this.currentUserProfile?.firstName} ${this.currentUserProfile?.lastName}`;
            link = `${process.env.VUE_APP_SITE_URL}/`
            message = `<p>Next, they must log in to authorize their credit card payment</p>`
            sendEmail({ to, subject, message }).catch(() => {})

            this.setTimelineStep(5)
            router.push(`/documents?uid=${this.currentUserProfile.uid}`).catch(() => {})
          })
        }
      )
    },
    clear() {
      // Clears the canvas
      this.signaturePad.clear()
      this.signatureDataUrl = null
    },
    submit() {
      this.pending = true

      this.generatePDF()
    },
    resizeCanvas() {
      // var ratio =  Math.max(window.devicePixelRatio || 1, 1)
      // this.$refs.canvas.width = this.$refs.canvas.offsetWidth * ratio
      // this.$refs.canvas.height = this.$refs.canvas.offsetHeight * ratio
      // this.$refs.canvas.getContext('2d').scale(ratio, ratio)
      // this.signaturePad.clear() // otherwise isEmpty() might return incorrect value
    }
  }
}
</script>

<style scoped lang='scss'>
@media print {
  .sign-engagement__letter {
    padding: 0 !important;
  }
}

.sign-engagement {
  h1 {
    text-align: center;
  }
  &__page {
    padding: 50px 0;
    background-color: white;
    width: 460pt;
    margin: 2rem auto;

    &__letter {
      background: white;
      padding: 20pt 30pt;

      p, td, strong {
        line-height: 1.5;
        font-family: Georgia, serif;
        font-size: .8rem;
        color: #000 !important;
      }
      &__logo {
        width: auto;
        img {
          width: 240px;
        }
      }
      table {
        width: 100%;
        background-color: transparent !important;

        tr {
          td {
            vertical-align: top;
            &.small {
              text-align: right;
              p {
                font-size: 10px;
                line-height: 1.2;
              }
            }
          }
        }
      }
      .spencer-signature {
        width: 200px;
        margin-bottom: -5px;
      }
      .signature-line {
        position: relative;
        border-bottom: solid 1px #000;

        .user-signature {
          width: 150px;
          display: block;
          bottom: -15px;
          position: absolute;
        }

      }
      .current-date {
        color: #000 !important;
      }
    }
  }
  &__footer {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5rem;
    canvas {
      max-width: 100%;
      border: solid 2px $c-border;
      cursor: crosshair;
    }
    &__actions {
      margin-top: 2rem;
      button {
        @include btn;
        &:first-child {
          @include btn-invert;
          margin-right: 1rem;
        }
        &:last-child {
          @include btn-secondary;
        }
      }
    }
  }
}
</style>